import React from "react";
import { Section, SectionHeading } from "../Section";
import { competingThoughts } from "../../data/landing";
export function StorySection() {
  return <Section tone="white" narrow cta="I want a clear starting point" data-id="element-252" data-mp="6xtzhvo2wkwl">
      <SectionHeading eyebrow="Why I created the Clinical Pathway™" title={<>
            From looking at breast augmentation cases… <em className="text-rose" data-id="element-254" data-mp="kvs96nrgft5r">to reviewing them with a system</em>
          </>} data-id="element-253" data-mp="bu12bfl6hgab" />

      <div className="mx-auto mt-10 max-w-2xl space-y-5 text-[17px] leading-relaxed text-inkSoft md:text-lg" data-id="element-255" data-mp="pubzf0d2zr3x">
        <p data-id="element-256" data-mp="uksd8lktdeqt">
          You can study breast augmentation. You can watch surgical demonstrations. You can attend conferences. You
          can read papers and review case discussions.
        </p>
        <p data-id="element-257" data-mp="14k1d1v2d1nl3">And still find yourself looking at a new educational case thinking:</p>
        <p className="border-l-4 border-rose pl-5 font-serif text-2xl font-bold italic text-ink md:text-3xl" data-id="element-258" data-mp="18l34vqty6xd1">
          “Where exactly should I start?”
        </p>
        <p data-id="element-259" data-mp="1vrgoq33idjf5">
          I understand that feeling. When you're looking at a new breast augmentation case, several things can compete
          for your attention at the same time:
        </p>
        <ul className="flex flex-wrap gap-2" aria-label="Things competing for your attention" data-id="element-260" data-mp="1lshon8wt6w3r">
          {competingThoughts.map(t => <li key={t} className="rounded-full border border-line bg-cream px-3.5 py-1.5 text-[15px] font-medium text-ink" data-id="element-261" data-mp="2egn9rwrryn44">
              {t}
            </li>)}
        </ul>
        <p data-id="element-262" data-mp="29jn1df7gd89u">
          And suddenly, instead of following a clear process, you're jumping from one thought to another.
        </p>
        <p className="font-semibold text-ink" data-id="element-263" data-mp="1zs0nfb3qcv3e">
          That's exactly why I created the Breast Augmentation Clinical Pathway™.
        </p>
        <p data-id="element-264" data-mp="2x8pj0n23714c">
          I didn't want to create another massive library of information. I wanted to create something you could
          actually use with a case in front of you.
        </p>
      </div>

      <div className="mx-auto mt-10 grid max-w-2xl grid-cols-3 divide-x divide-line rounded-2xl bg-ink py-6 text-center text-white" data-id="element-265" data-mp="qje555vdbmy5">
        {[["One", "case"], ["One", "structured process"], ["~15", "minutes"]].map(([big, small]) => <div key={small} className="px-2" data-id="element-266" data-mp="lr4690c9zcjq">
            <p className="font-serif text-3xl font-bold md:text-4xl" data-id="element-267" data-mp="lpt2h0ity4sm">{big}</p>
            <p className="mt-1 text-[13px] text-white/75 md:text-sm" data-id="element-268" data-mp="7qthc2uj0817">{small}</p>
          </div>)}
      </div>
    </Section>;
}